import { Component } from '@angular/core';

@Component({
  selector: 'app-scenario-assessment-link',
  templateUrl: './scenario-assessment-link.component.html',
  styleUrls: ['./scenario-assessment-link.component.scss']
})
export class ScenarioAssessmentLinkComponent {

}
